import Collection from './Collection';

export default Collection;



// WEBPACK FOOTER //
// ./src/components/Collection/index.js